export default "__VITE_ASSET__BffTC_MF__"